import { RxJsonSchema, RxDocument } from 'rxdb';
import { ScoutPointPhoto, ScoutPointLocalPhoto, ScoutPointLocalPhotoUrl } from '../models';


export const scoutPointPhotoMethods = {
}

export type ScoutPointPhotoDoc = RxDocument<ScoutPointPhoto,typeof scoutPointPhotoMethods>

export const scoutPointPhotoSchema: RxJsonSchema<ScoutPointPhoto> = {
    title: 'scout photo schema',
    version: 1,
    keyCompression: false,
    type: 'object',
    properties: {
        _id: {
            type: 'string',
            primary: true,
            default: ''
        },
        scoutPointId: {
            type: 'string'
        },
        userId: {
            type: 'string'
        },
        fileName: {
            type: ['string', 'null']
        },
        fileChecksum: {
            type: ['string','null']
        },
        mimeType: {
            type: ['string', 'null']
        },
        title: {
            type: ['string', 'null']
        },
        notes: {
            type: ['string', 'null']
        },
        group: {
            type: 'string'
        },
        groupOrderIndex: {
            type: 'number'
        },
        pointType: {
            type: 'string'
        },
        uploadDate:{ 
            type: ['string', 'null']
        },
        modifiedDate: {
            type: 'string'
        }
    },

    required: ['_id','scoutPointId', 'userId', 'modifiedDate'],
    
    indexes: [
        'scoutPointId', 
        'userId', 
        ['userId','uploadDate','fileName'],
        ['uploadStartDate', 'uploadDate', 'errorMsg' ]
    ]
};


